import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Typography } from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";
import { AppColors } from "../../../util/AppColors";
import { extensionToMime } from "../../../util/function";

const DiagnosticsView = ({ diagnostics, showFileAlso = false }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  const renderFiles = (files = []) => {
    return files?.map((fle, i) => {
      const mimeType =
        extensionToMime[
          fle?.split(".").pop().split("?")[0].toLowerCase()
        ]?.split("/")?.[0];

      return (
        <div
          style={{
            display: "inline-block",
            position: "relative",
            marginLeft: i !== 0 ? 15 : 0,
          }}
          key={i + mimeType}
        >
          {mimeType === "application" ? (
            <PictureAsPdfIcon
              className="upload-pdf"
              sx={{ color: AppColors.redBtn }}
            />
          ) : mimeType === "image" || !mimeType ? (
            <img className="upload-img" alt="" src={fle} />
          ) : mimeType === "video" ? (
            <video className="upload-img" alt="" src={fle} />
          ) : null}
        </div>
      );
    });
  };

  const renderRecord = () => {
    return (
      (diagnostics ?? reqDet?.diagnostics)
        // ?.filter((li) => li?.status?.toLowerCase() === "completed")
        ?.map((li, i) => {
          return (
            <div key={Date.now() + i}>
              <div className="flex-row ph10 mv5">
                <div className="w50Per pr5">
                  <Typography className="fs12 font-medium black4">
                    {li?.testName}
                  </Typography>
                </div>
                <div className="w35Per pr5">
                  <Typography className="fs12 font-medium black4">
                    {li?.type}
                  </Typography>
                </div>
                <div className="w15Per pr5">
                  <Typography className="fs12 font-medium black4">
                    {moment(li?.dueDate).format("DD MMM YYYY")}
                  </Typography>
                </div>
              </div>
              {showFileAlso ? renderFiles(li?.file) : null}
            </div>
            // <div className="gray-back-con1 mv5" key={Date.now() + i}>
            //   <div className="flex-row-ali-cen flex-row-wrap">
            //     <Typography className="txt-semi-bold black fs12">
            //       Name: {li?.testName}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Type: {li?.type}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Due Date: {moment(li?.dueDate).format("DD MMM YYYY")}
            //     </Typography>
            //   </div>
            // </div>
          );
        })
    );
  };

  return (
    <div>
      {/* <div className="blk-hor-split mv3" /> */}
      <div className="flex-row-ali-cen ph10">
        <div className="w50Per">
          <Typography className="fs12 txt-semi-bold black">Name</Typography>
        </div>
        <div className="w35Per">
          <Typography className="fs12 txt-semi-bold black">Type</Typography>
        </div>
        <div className="w15Per">
          <Typography className="fs12 txt-semi-bold black">Due Date</Typography>
        </div>
      </div>
      <div className="blk-hor-split mb3 mt10" />
      {renderRecord()}
      {/* <div className="blk-hor-split mv3" /> */}
    </div>
  );
};

export default DiagnosticsView;
